var ISubGeometry = (function () {
    function ISubGeometry() {
    }
    return ISubGeometry;
}());
export { ISubGeometry };
